import type * as lazyIndex from './lazyIndex';
import { LazyModule, LazyAction, LazyImport } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "UserStorage" */ './lazyIndex'),
    { name: 'UserStorage' }
);

export const lazyGetAccountInformation: LazyAction<
    typeof lazyIndex.getAccountInformation,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAccountInformation);
export const lazyOpenedStoragePageOnFull: LazyAction<
    typeof lazyIndex.openedStoragePageOnFull,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.openedStoragePageOnFull);
export const lazyGetStorageStore: LazyImport<typeof lazyIndex.getStorageStore, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.getStorageStore);

export const lazyTryValidateDumpsterQuota: LazyImport<
    typeof lazyIndex.tryValidateDumpsterQuota,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.tryValidateDumpsterQuota);

export const lazyShouldDisableSend: LazyImport<
    typeof lazyIndex.shouldDisableSend,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.shouldDisableSend);

export const lazyGetLocalStorageKeyName: LazyImport<
    typeof lazyIndex.getLocalStorageKeyName,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getLocalStorageKeyName);

export const lazyGetMicrosoftStorageData: LazyAction<
    typeof lazyIndex.getMicrosoftStorageData,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getMicrosoftStorageData);

export const lazymailDeletionTriggerStorageUpdate: LazyAction<
    typeof lazyIndex.mailDeletionTriggerStorageUpdate,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.mailDeletionTriggerStorageUpdate);

export const lazyOnStorageUpsell: LazyAction<typeof lazyIndex.onStorageUpsell, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.onStorageUpsell);

export {
    EnforcementState_Active,
    BB_CRITICAL_D_TIME,
    BB_NEARING_D_TIME,
    EnforcementState_Revoked,
    BASIC_TIER_STORAGE_CAP,
    PREMIUM_TIER_STORAGE_CAP,
} from './util/constants';

export { onDismissLeftNavBar } from './actions/onDismissLeftNavBar';
